import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService } from '@app/core/services';

@Injectable({ providedIn: 'root' })
export class HomeNavigationResolver implements Resolve<boolean> {
	constructor(private readonly navigationService: NavigationService) {}

	resolve(): Observable<boolean> {
		return this.navigationService.navigateToHomePage();
	}
}
